<template>
  <div v-scroll="handleScroll" class="section-wrapper">
    <SectionTitle title="Projects" />
    <div class="section-content">
      <Project
        v-for="(item, i) in media"
        v-scroll-reveal.reset="
          i % 2 === 0 ? vScrollOpts.right : vScrollOpts.left
        "
        :key="item.key"
        :index="i + 1"
        :projectData="item"
      />
    </div>
    <div class="router-link-wrapper" v-scroll-reveal.reset>
      <router-link class="router-link" to="/projects">
        MORE PROJECTS
      </router-link>
    </div>
  </div>
</template>

<script>
  import SectionTitle from '@/commonComponents/SectionTitle'
  import Project from './Project'
  import { chickenMeetsWorm, travelog, pixilz, birds } from './projectsData'
  import { mapActions, mapState } from 'vuex'

  export default {
    components: {
      SectionTitle,
      Project
    },
    data() {
      return {
        media: [chickenMeetsWorm, travelog, pixilz, birds]
      }
    },
    computed: {
      ...mapState(['vScrollOpts'])
    },
    methods: {
      ...mapActions(['getScrollPos']),
      openGallery(index) {
        this.$refs.lightbox.showImage(index)
      },
      handleScroll(evt, el) {
        this.getScrollPos(el)
      }
    }
  }
</script>

<style scoped lang="scss">
  @include section;
  .router-link-wrapper {
    padding: 1.5rem;
    padding-top: 4rem;
    padding-bottom: 5rem;
    .router-link {
      @include underline-on-hover($yellow-light);
      color: $yellow-light;
      font-size: 1.5rem;
      padding: 0.75rem 1rem;
    }
  }
</style>
